import { gql } from '@apollo/client';

export const PLAN_CREATE = gql`
  mutation PlanCreate(
    $planOwnerId: String!
    $title: String!
    $description: String!
    $url: String!
    $image: String!
    $specifications: JSON
    $photos: [JSON!]!
    $decorId: String
    $isHidden: Boolean
    $meta: JSON
    $planSVG: String
    $planId: String
    $hasARModel: Boolean
    $arModelLink: String
    $planCost: Float
    $isModular: Boolean
    $isManufactured: Boolean
    $preApproved: Boolean
    $fixPrice: Float
    $sourcePlan: String
    $available: JSON
    $preApprovedArea: JSON
  ) {
    planCreate(
      planOwnerId: $planOwnerId
      title: $title
      description: $description
      url: $url
      image: $image
      specifications: $specifications
      photos: $photos
      decorId: $decorId
      planSVG: $planSVG
      planId: $planId
      isHidden: $isHidden
      meta: $meta
      hasARModel: $hasARModel
      arModelLink: $arModelLink
      planCost: $planCost
      isModular: $isModular
      isManufactured: $isManufactured
      preApproved: $preApproved
      fixPrice: $fixPrice
      sourcePlan: $sourcePlan
      available: $available
      preApprovedArea: $preApprovedArea
    ) {
      id
      planOwnerId
      title
      url
      specifications
      photos
      meta
      planId
      hasARModel
      arModelLink
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      sourcePlan
      available
      preApprovedArea
    }
  }
`;

export const PLAN_UPDATE = gql`
  mutation PlanUpdate(
    $id: ID!
    $planOwnerId: String!
    $title: String!
    $description: String!
    $url: String!
    $image: String!
    $specifications: JSON
    $photos: [JSON!]!
    $decorId: String
    $isHidden: Boolean
    $meta: JSON
    $planSVG: String
    $planId: String
    $hasARModel: Boolean
    $arModelLink: String
    $planCost: Float
    $isModular: Boolean
    $isManufactured: Boolean
    $preApproved: Boolean
    $fixPrice: Float
    $sourcePlan: String
    $available: JSON
    $preApprovedArea: JSON
  ) {
    planUpdate(
      id: $id
      planOwnerId: $planOwnerId
      title: $title
      description: $description
      url: $url
      image: $image
      specifications: $specifications
      photos: $photos
      decorId: $decorId
      isHidden: $isHidden
      meta: $meta
      planSVG: $planSVG
      planId: $planId
      hasARModel: $hasARModel
      arModelLink: $arModelLink
      planCost: $planCost
      isModular: $isModular
      isManufactured: $isManufactured
      preApproved: $preApproved
      fixPrice: $fixPrice
      sourcePlan: $sourcePlan
      available: $available
      preApprovedArea: $preApprovedArea
    ) {
      id
      planOwnerId
      description
      title
      url
      specifications
      photos
      decorId
      isHidden
      meta
      planId
      hasARModel
      arModelLink
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      sourcePlan
      available
      preApprovedArea
    }
  }
`;
